/**
 * Stable Pitch2Table URL that 302s to the TTGDA licensing scoring rubric.
 * Destination is owned by public-api (`/go/:slug`) so it can move without a web release.
 */
export const TTGDA_LICENSING_SCORING_RUBRIC_URL =
  "https://public.pitch2table.com/go/ttgda-licensing-scoring-rubric";
